class DeliveryTime extends HTMLElement {
    constructor() {
        super();

        this.formatString = this.getAttribute("data-frm-day");
        this.excludedDays = this.getAttribute("data-exclude-day")
            .replace(/ /g, '')
            .split(",");
        this.numbDateStart = this.getAttribute("data-estimate-start");
        this.numbDateEnd = this.getAttribute("data-estimate-end");
        this.targetTime = this.getAttribute("data-time");

        this.hr = this.querySelector('.productView-dlvr__remaining-hr');
        this.mins = this.querySelector('.productView-dlvr__remaining-mins');

        this.productDeliveryTime();

        const countdown = this.countdownToTime(this.targetTime);
        if (this.hr) this.hr.innerHTML = countdown.hours;
        if (this.mins) this.mins.innerHTML = countdown.minutes;

        this.style.display = "block";

        setInterval(() => {
            const countdown = this.countdownToTime(this.targetTime);
            if (this.hr) this.hr.innerHTML = countdown.hours;
            if (this.mins) this.mins.innerHTML = countdown.minutes;
        }, 1000);
    }

    getItalyDate() {
        return new Date(
            new Intl.DateTimeFormat('en-US', {
                timeZone: 'Europe/Rome',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            }).format(new Date())
        );
    }

    getCutoffDate(targetTime) {
        const now = this.getItalyDate();
        const [h, m, s] = targetTime.split(':').map(Number);

        const cutoff = new Date(now);
        cutoff.setHours(h, m, s || 0, 0);

        return cutoff;
    }

    getBaseDeliveryDate() {
        const now = this.getItalyDate();
        const cutoff = this.getCutoffDate(this.targetTime);

        let baseDate = new Date(now);
        baseDate.setHours(0, 0, 0, 0);

        if (now >= cutoff) {
            baseDate.setDate(baseDate.getDate() + 1);
        }

        const excludedIndexes = this.excludedDays.map(day =>
            ['SUN','MON','TUE','WED','THU','FRI','SAT'].indexOf(day)
        );

        // 👉 Ensure baseDate is a WORKING day
        while (excludedIndexes.includes(baseDate.getDay())) {
            baseDate.setDate(baseDate.getDate() + 1);
        }

        return baseDate;
    }

    formatDate(dateString, formatString) {
        const date = new Date(dateString);
        const locale = 'it-IT';

        const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long' }),
            dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit' }),
            month = date.toLocaleDateString(locale, { month: 'short' }),
            monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'),
            year = date.toLocaleDateString(locale, { year: 'numeric' });

        return formatString
            .replace('d', dayOfWeek)
            .replace('DD', dayOfMonth)
            .replace('MMM', month)
            .replace('MM', monthNumber)
            .replace('YYYY', year);
    }

    // excludeDays(excludedDays, dataRange) {
    //     const now = this.getItalyDate();
    //     const cutoff = this.getCutoffDate(this.targetTime);

    //     const deliveryDateTime = new Date(
    //         now < cutoff ? now : new Date(now.setDate(now.getDate() + 1))
    //     );

    //     const excludedIndexes = excludedDays.map(day =>
    //         ['SUN','MON','TUE','WED','THU','FRI','SAT'].indexOf(day)
    //     );

    //     let addedDays = 0;

    //     while (addedDays < parseInt(dataRange)) {
    //         if (!excludedIndexes.includes(deliveryDateTime.getDay())) {
    //             addedDays++;
    //         }
    //         if (addedDays < dataRange) {
    //             deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
    //         }
    //     }

    //     return deliveryDateTime;
    // }
    excludeDays(excludedDays, dataRange) {
        let date = this.getBaseDeliveryDate();

        const excludedIndexes = excludedDays.map(day =>
            ['SUN','MON','TUE','WED','THU','FRI','SAT'].indexOf(day)
        );

        let addedDays = 0;
        const totalDays = parseInt(dataRange, 10);

        while (addedDays < totalDays) {
            date.setDate(date.getDate() + 1);

            if (!excludedIndexes.includes(date.getDay())) {
                addedDays++;
            }
        }

        return date;
    }

    countdownToTime(targetTime) {
        const currentTime = this.getItalyDate();
        const targetDateTime = new Date(
            `${currentTime.toDateString()} ${targetTime}`
        );

        if (targetDateTime < currentTime) {
            targetDateTime.setDate(targetDateTime.getDate() + 1);
        }

        const remainingTime = targetDateTime - currentTime;

        return {
            hours: Math.floor(remainingTime / (1000 * 60 * 60)),
            minutes: Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60))
        };
    }
    productDeliveryTime() {
        const orderDlvr = document.querySelectorAll("[data-delivery-time]");
        if (!orderDlvr.length) return;

        let startDay = this.excludeDays(this.excludedDays, this.numbDateStart);
        let endDay = this.excludeDays(this.excludedDays, this.numbDateEnd);

        const formattedStartDate = this.formatDate(startDay, this.formatString);
        const formattedEndDate = this.formatDate(endDay, this.formatString);

        orderDlvr.forEach(el => {
            const startEl = el.querySelector('[data-start-delivery]');
            const endEl = el.querySelector('[data-end-delivery]');

            if (startEl) startEl.innerHTML = formattedStartDate;
            if (endEl) endEl.innerHTML = formattedEndDate;
        });
    }
}

customElements.define('delivery-time', DeliveryTime);




// class DeliveryTime extends HTMLElement {
//     constructor() {
//         super();

//         this.formatString = this.getAttribute("data-frm-day");
//         this.excludedDays = this.getAttribute("data-exclude-day")
//             .replace(/ /g, '')
//             .split(",");
//         this.numbDateStart = this.getAttribute("data-estimate-start");
//         this.numbDateEnd = this.getAttribute("data-estimate-end");
//         this.targetTime = this.getAttribute("data-time");
//         this.targetLocale = this.getAttribute("data-locale") || 'en-US';

//         this.hr = this.querySelector('.productView-dlvr__remaining-hr');
//         this.mins = this.querySelector('.productView-dlvr__remaining-mins');
//         this.iso_code = document.documentElement.lang;

//         // this.checkExclude = this.checkAllExcludeDays(this.excludedDays);
//         // if (this.checkExclude) return;

//         this.productDeliveryTime();

//         const countdown = this.countdownToTime(this.targetTime);
//         if (this.hr) this.hr.innerHTML = countdown.hours;
//         if (this.mins) this.mins.innerHTML = countdown.minutes;

//         this.style.display = "block";

//         setInterval(() => {
//             const countdown = this.countdownToTime(this.targetTime);
//             if (this.hr) this.hr.innerHTML = countdown.hours;
//             if (this.mins) this.mins.innerHTML = countdown.minutes;
//         }, 1000);
//     }

//     checkAllExcludeDays(excludedDays) {
//         const now = new Date();
//         const timeZone = 'Europe/Rome';
        
//         const dayNameInItaly = now.toLocaleDateString('en-US', { weekday: 'short', timeZone: timeZone }).toUpperCase();
//         const dayInItalyIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(dayNameInItaly);

//         for (let day of excludedDays) {
//             const dayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);
//             if (dayInItalyIndex === dayIndex) return true;
//         }

//         return false;
//     }

//     getShipmentDelayDays() {

//     //     if (this.getAttribute('data-force-delay') === '1') {
//     //     return 1;
//     // }
//         const currentTime = new Date();
//         const timeZone = 'Europe/Rome';
        
//         const options = {
//             hour: '2-digit',
//             minute: '2-digit',
//             hour12: false,
//             timeZone: timeZone
//         };
        
//         const timeString = currentTime.toLocaleTimeString('it-IT', options);
//         const [currentHour, currentMinute] = timeString.split(':').map(Number);
        
//         const [targetHour, targetMinute] = this.targetTime.split(':').map(Number);
        
//         if (currentHour > targetHour || (currentHour === targetHour && currentMinute >= targetMinute)) {
//             return 1; 
//         }
//         return 0; 
        
//     }
    
//     productDeliveryTime() {
//         const orderDlvr = document.querySelectorAll("[data-delivery-time]");
//         if (orderDlvr.length === 0) return;

//         const shipmentDelayDays = this.getShipmentDelayDays();

//         const adjustedStartDateRange = parseInt(this.numbDateStart) + shipmentDelayDays;
//         const adjustedEndDateRange = parseInt(this.numbDateEnd) + shipmentDelayDays;
        
//         let startDay = this.excludeDays(this.excludedDays, adjustedStartDateRange);

// // END = START + data-estimate-end
// let endDay = new Date(startDay);
// endDay.setDate(endDay.getDate() + parseInt(this.numbDateEnd) - 1);
// endDay = this.excludeDays(this.excludedDays, 
//   Math.round((endDay - new Date()) / (1000 * 60 * 60 * 24))
// );


//         const formattedStartDate = this.formatDate(startDay, this.formatString);
//         const formattedEndDate = this.formatDate(endDay, this.formatString);

//         orderDlvr.forEach(el => {
//             const startEl = el.querySelector('[data-start-delivery]');
//             const endEl = el.querySelector('[data-end-delivery]');
            
//             if (startEl) startEl.innerHTML = formattedStartDate;
//             if (endEl) endEl.innerHTML = formattedEndDate;
//         });
//     }

//     formatDate(dateString) {
//         const date = new Date(dateString);
//         const locale = this.targetLocale; 
//         const timeZone = 'Europe/Rome';
        
//         const dateOptions = { timeZone: timeZone };
        
//         const dayOfWeek = date.toLocaleDateString(locale, { weekday: 'long', ...dateOptions }), 
//             dayOfMonth = date.toLocaleDateString(locale, { day: '2-digit', ...dateOptions }),
//             month = date.toLocaleDateString(locale, { month: 'long', ...dateOptions }), 
//             monthNumber = (date.getMonth() + 1).toString().padStart(2, '0'), 
//             year = date.toLocaleDateString(locale, { year: 'numeric', ...dateOptions });

        
//         const formattedDate = this.formatString
//             .replace('d', dayOfWeek)
//             .replace('DD', dayOfMonth)
//             .replace('MMM', month)
//             .replace('MM', monthNumber)
//             .replace('YYYY', year);

//         return formattedDate;
//     }

//     excludeDays(excludedDays, dataRange) {
//         const now = new Date(),
//             deliveryDateTime = new Date(now);
//         const timeZone = 'Europe/Rome';

//         deliveryDateTime.setDate(deliveryDateTime.getDate() + parseInt(dataRange));
        
//         excludedDays.forEach(day => {
//             const excludedDayIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(day);

//             let isExcludedDay = true;
//             while (isExcludedDay) {
//                 const dayNameInItaly = deliveryDateTime.toLocaleDateString('en-US', { weekday: 'short', timeZone: timeZone }).toUpperCase();
//                 const dayInItalyIndex = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'].indexOf(dayNameInItaly);

//                 if (dayInItalyIndex === excludedDayIndex) {
//                     deliveryDateTime.setDate(deliveryDateTime.getDate() + 1);
//                 } else {
//                     isExcludedDay = false; 
//                 }
//             }
//         });

//         return deliveryDateTime.toLocaleDateString('en-US');
//     }

 
//     countdownToTime(targetTime) {
//         const currentTime = new Date();
//         const timeZone = 'Europe/Rome';
        
//         const options = {
//             year: 'numeric',
//             month: 'numeric',
//             day: 'numeric',
//             timeZone: timeZone
//         };

//         const formatter = new Intl.DateTimeFormat('en-US', options);
//         const parts = formatter.formatToParts(currentTime);
        
//         const year = parts.find(p => p.type === 'year').value;
//         const month = parts.find(p => p.type === 'month').value;
//         const day = parts.find(p => p.type === 'day').value;
        
//         const [targetHour, targetMinute] = targetTime.split(':').map(Number);
        
  
//         const offsetFormatter = new Intl.DateTimeFormat('en-US', {
//             timeZoneName: 'shortOffset',
//             timeZone: timeZone
//         });
//         const offsetString = offsetFormatter.format(currentTime);
        
//         let offsetHours = 0;
//         if (offsetString.includes('GMT+')) {
//             offsetHours = parseInt(offsetString.split('GMT+')[1], 10);
//         } else if (offsetString.includes('GMT-')) {
//             offsetHours = -parseInt(offsetString.split('GMT-')[1], 10);
//         }
        
       
//         const targetDateTimeIT = new Date(Date.UTC(
//             year, 
//             month - 1, 
//             day, 
//             targetHour - offsetHours, 
//             targetMinute, 
//             0
//         ));
        
//         if (targetDateTimeIT.getTime() < currentTime.getTime()) {
//             targetDateTimeIT.setUTCDate(targetDateTimeIT.getUTCDate() + 1);
//         }
        
//         const remainingTime = targetDateTimeIT.getTime() - currentTime.getTime();

//         const hours = Math.floor(remainingTime / (1000 * 60 * 60));
//         const minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));

//         return { hours, minutes };
//     }
// }
// customElements.define('delivery-time', DeliveryTime);